const runtime = (typeof window !== 'undefined' && window._env_) || {};

const isMeaningful = (value) => value !== undefined && value !== null && value !== '';

/**
 * Reads configuration with runtime precedence:
 * 1. window._env_ (generated by docker-entrypoint.sh at container startup)
 * 2. process.env (baked into the bundle at build time, used as fallback)
 */
export const getEnv = (key) => {
    const runtimeValue = runtime[key];
    return isMeaningful(runtimeValue) ? runtimeValue : process.env[key];
};

// Bilinmeyen ortam '' döner; ortam kısıtlı öğeler o durumda gizlenir.
const API_HOST_ENVIRONMENTS = {
    'dms-api.karsan.com.tr': 'prod',
    'dms-api-test.karsan.com.tr': 'test',
    'api-dev.karsan.com.tr': 'dev',
    localhost: 'local'
};

// local | dev | test | prod — container'da REACT_APP_ENVIRONMENT verilirse o, yoksa API adresinden.
export const getAppEnvironment = () => {
    const explicit = runtime.REACT_APP_ENVIRONMENT;
    if (isMeaningful(explicit)) return String(explicit).trim().toLowerCase();
    try {
        return API_HOST_ENVIRONMENTS[new URL(getEnv('REACT_APP_API_URL')).hostname] || '';
    } catch {
        return '';
    }
};
